import type { DatadogDebugScope } from 'src/observability/datadog-debug-links';

import { update, showNewMessage } from '@intercom/messenger-js-sdk';

import { currentDatadogDebugLinks } from 'src/observability/datadog-debug-links';

// ----------------------------------------------------------------------

function debuggingContext(scope: DatadogDebugScope) {
  const { session, logsUrl } = currentDatadogDebugLinks(scope);

  return {
    datadog_session_id: session?.id ?? '',
    datadog_session_url: session?.url ?? '',
    datadog_logs_url: logsUrl ?? '',
  };
}

/**
 * Opens a new Messenger conversation after stamping the recruiter's Intercom profile with this
 * moment's Datadog links, blank where there are none (a browser that blocks tracking has no session)
 * so nothing carries over from an earlier report. The support inbox and the triage agent both read
 * these attribute names.
 */
export function startIssueReport(recruiter: DatadogDebugScope) {
  update(debuggingContext(recruiter));
  showNewMessage('');
}
